import { Component, Input } from '@angular/core';

/**
 * Barra de título y ruta de la pantalla.
 *
 * Envuelve a ng-dynamic-breadcrumb, que arma las migas leyendo el `data.breadcrumb`
 * de cada ruta. La librería sólo genera el marcado; todo el aspecto se define acá,
 * así que cambiar el estilo de la barra es tocar un archivo y no 60 pantallas.
 *
 * Los colores son @Input por si alguna pantalla necesita destacarse, pero la
 * intención es que casi nadie los pase: el valor de una barra de título es que
 * sea siempre igual.
 */
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {

  /** Color de los tramos que sí son enlaces */
  @Input() colorEnlace: string = '#00796b';

  /** Color del tramo actual, que no es enlace */
  @Input() colorActual: string = 'rgba(0, 0, 0, .75)';

  /** Separador entre tramos */
  @Input() separador: string = '/';

  /**
   * El fondo lo pone el CSS del componente, no la librería: así conviven el
   * color y el borde, que la librería no sabe dibujar.
   */
  readonly fondoTransparente = 'transparent';
}
